export function getTotalCost(scenario) {
    return scenario?.pricing?.upfrontIncVat_GBP ?? scenario?.pricing?.upfrontExVat_GBP ?? null;
}

export function getAnnualSavings(scenario) {
    return scenario?.financials?.annualSavings_GBP ?? scenario?.savings_GBP ?? null;
}

export function getPackageName(scenario) {
    return scenario?.title || scenario?.tier || scenario?.bundleId || 'Package';
}

export function getPanelCount(scenario) {
    return scenario?.design?.panelCount ?? scenario?.panelCount ?? null;
}

export function getBatteryCount(scenario) {
    return scenario?.batteryCount ?? null;
}
